import { publicRequest } from "../../../requestMeth";
import {
  devicesStart,
  devicesSuccess,
  devicesFailure,
  deleteStart,
  deleteSuccess,
  deleteFailure,
  discoveredDevicesStart,
  discoveredDevicesSuccess,
  discoveredDevicesFailure
} from "../../reducers/admin/devicesRedux";

export const getAlldevices = async (dispatch, token, selected) => {
  dispatch(devicesStart());
  try {
    const res = await publicRequest.get(`/admin/devices`, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(devicesSuccess(res.data));
  } catch (error) {
    dispatch(devicesFailure());
  }
};

export const deleteDevice = async (dispatch, id, token) => {
  dispatch(deleteStart());
  try {
    const res = await publicRequest.delete(`/admin/devices/delete/${id}`, {
      headers: { token: `Bearer ${token}` },
    });
    dispatch(deleteSuccess(res.data));
  } catch (error) {
    dispatch(deleteFailure());
  }
};

export const getDiscoveredDevices = async (dispatch, token) => {
  dispatch(discoveredDevicesStart());
  try {
    const res = await publicRequest.get(`/admin/devices/discovered`, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(discoveredDevicesSuccess(res.data.devices));
  } catch (error) {
    dispatch(discoveredDevicesFailure());
  }
};
